import { render, staticRenderFns } from "./DialogAmigos.vue?vue&type=template&id=1a9336ec&scoped=true&"
import script from "./DialogAmigos.vue?vue&type=script&lang=js&"
export * from "./DialogAmigos.vue?vue&type=script&lang=js&"
import style0 from "./DialogAmigos.vue?vue&type=style&index=0&id=1a9336ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9336ec",
  null
  
)

export default component.exports